module.exports = __webpack_public_path__ + "static/media/layout-8.4380c382.svg";